
<div class="neq-page-wrapper">
  <div fxFlex="1 1 auto" fxLayout="row" class="neq-container">
    <div fxFlex="50" [formGroup]="mandatoryForm">
      <div fxLayout="row">
        {{'label.common.entity' | translate}} *
      </div>
      <div *ngIf="selectedEntity" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
        <img *ngIf="selectedEntity.logo" [src]="selectedEntity.logo" alt="logo"> &nbsp;
        <span class="society">{{selectedEntity.name}}</span>
      </div>
      <neq-select-autocomplete (change)="onEntityChange($event)" [dataSource]="searchEntity"
                                formControlName="entity" [redColor]="isFormInvalidAndTouched('entity')"></neq-select-autocomplete>
      <div *ngIf="isFormInvalidAndTouched('entity')">
        <mat-error *ngIf="mandatoryForm.controls.entity.errors?.required">
          {{'error.common.field-required' | translate}}
        </mat-error>
      </div>

      <div fxLayout="row" *ngIf="isThereLinkedBu">
        <div fxFlex>
          <mat-form-field>
            <input [placeholder]="'label.common.business-unit' | translate" disabled
                    matInput value="{{callStaticCodeAndLabel(selectedBusinessUnit)}}">
          </mat-form-field>
        </div>
      </div>
      <div style="margin-bottom: 0px; margin-top: 1.667rem;" [hidden]="isThereLinkedBu">
        <div fxLayout="row">
          {{'label.common.business-unit' | translate}} *
        </div>
        <neq-select-autocomplete (change)="onBusinessUnitChange($event)" [dataSource]="searchBusinessUnit"
                                  formControlName="businessUnit" [redColor]="isFormInvalidAndTouched('businessUnit')"></neq-select-autocomplete>
      </div>
      <div *ngIf="isFormInvalidAndTouched('businessUnit')">
        <mat-error *ngIf="mandatoryForm.controls.businessUnit.errors?.required">
          {{'error.common.field-required' | translate}}
        </mat-error>
      </div>

      <div fxLayout="row" *ngIf="isThereLinkedCustomer">
        <div fxFlex>
          <mat-form-field>
            <input [placeholder]="'label.common.customer' | translate" disabled
                    matInput value="{{callStaticCodeAndLabel(selectedCustomer)}}">
          </mat-form-field>
        </div>
      </div>
      <div style="margin-bottom: 0px; margin-top: 1.667rem;" [hidden]="isThereLinkedCustomer">
        <div fxLayout="row">
          {{'label.common.customer' | translate}} *
        </div>
        <neq-select-autocomplete [(ngModel)]="sampleCustomerIdentifier" #customerSelector (change)="onCustomerChange($event)" [dataSource]="searchCustomer"
                                  formControlName="customer" [redColor]="isFormInvalidAndTouched('customer')"></neq-select-autocomplete>
      </div>
      <div *ngIf="isFormInvalidAndTouched('customer')">
        <mat-error *ngIf="mandatoryForm.controls.customer.errors?.required">
          {{'error.common.field-required' | translate}}
        </mat-error>
      </div>

      <div fxLayout="row">
        <div fxFlex>
          <mat-form-field>
            <input select-all [placeholder]="'label.common.code' | translate" formControlName="code" matInput required>
            <mat-error *ngIf="mandatoryForm.controls.code.errors?.required">
              {{'error.common.field-required' | translate}}
            </mat-error>
            <mat-error *ngIf="mandatoryForm.controls.code.errors?.maxlength" [translateParams]="{param: 50}"
                        translate="error.common.text.max"
            ></mat-error>
            <mat-error *ngIf="mandatoryForm.controls.code.errors?.pattern">
              {{'error.common.text.character.invalid' | translate}}
            </mat-error>
            <mat-error *ngIf="mandatoryForm.controls.code.errors?.unique">
              {{'error.common.code.unique'| translate}}
            </mat-error>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row">
        <div fxFlex>
          <mat-form-field>
            <input select-all [placeholder]="'label.common.label' | translate" formControlName="label" matInput required>
            <mat-error *ngIf="mandatoryForm.controls.label.errors?.required">
              {{'error.common.field-required' | translate}}</mat-error>
            <mat-error *ngIf="mandatoryForm.controls.label.errors?.maxlength" [translateParams]="{param: 255}"
                        translate="error.common.text.max"
            ></mat-error>
          </mat-form-field>
        </div>
      </div>

      <div fxLayout="row">
        <div fxFlex>
          <div class="mat-form-field" fxFlex="95" fxLayout="column" fxLayoutAlign="center none">
            <div fxLayout="row"><span>{{'label.common.reference' | translate}} *</span></div>
            <div fxLayout="row" fxLayoutAlign="start center">
              <neq-select-autocomplete (change)="onReferenceChange($event)" [dataSource]="searchReference"
                                        formControlName="reference" [redColor]="isFormInvalidAndTouched('reference')" fxFlex
              >
              </neq-select-autocomplete>

              <neq-icon (click)="openAdvancedReferenceSearch()" (keyPress)="openAdvancedReferenceSearch()"
                        [matTooltip]="'label.common.search.advanced' | translate"
                        svgIcon="recherche"></neq-icon>
            </div>
          </div>
        </div>
      </div>

      <div fxLayout="row" *ngIf="selectedReference">
        <div fxFlex *ngIf="selectedReference.description">
          <mat-form-field>
            <input [placeholder]="'label.common.reference.description' | translate" disabled
                    matInput value="{{selectedReference?.description}}">
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="selectedReference" fxLayout="row">
        <div fxFlex>
          <mat-form-field>
            <input [placeholder]="'label.common.reference.prediction-model' | translate" disabled
                    matInput value="{{selectedReference.predictionModelLabel}}">
          </mat-form-field>
        </div>
        <div fxFlex *ngIf="selectedReference.predictionModelDescription" >
          <mat-form-field>
            <input [placeholder]="'label.common.prediction-model.description' | translate" disabled
                    matInput value="{{selectedReference.predictionModelDescription}}">
          </mat-form-field>
        </div>
      </div>
      <div *ngIf="isFormInvalidAndTouched('reference')">
        <mat-error *ngIf="mandatoryForm.controls.reference.errors?.required">
          {{'error.common.field-required'| translate}}
        </mat-error>
      </div>
    </div>


    <div fxFlex="50" [formGroup]="mandatoryForm">
        <div fxLayout="row">
          {{'label.common.species-in-singular' | translate}} *
        </div>
        <neq-select-autocomplete [dataSource]="searchSpecies"
                                  formControlName="species" [redColor]="isFormInvalidAndTouched('species')"></neq-select-autocomplete>
        <div *ngIf="isFormInvalidAndTouched('species')">
          <mat-error *ngIf="mandatoryForm.controls.species.errors?.required">
            {{'error.common.field-required' | translate}}
          </mat-error>
        </div>

        <div fxLayout="row">
          <div fxFlex>
            <div class="mat-form-field" fxLayout="column" fxLayoutAlign="center none">
              <div fxLayout="row">
                {{ 'label.common.validation-date' | translate }} *
              </div>
                <p-calendar fxFlex="100"
                  id="validationDatePicker"
                  dateFormat="{{returnDateFormat()}}"
                  formControlName="validationDate"
                ></p-calendar>
              <div *ngIf="isFormInvalidAndTouched('validationDate')">
                <mat-error *ngIf="mandatoryForm.controls.validationDate.errors?.required">
                  {{ 'error.common.field-required' | translate }}
                </mat-error>
              </div>
            </div>
          </div>
        </div>

        <div fxLayout="row">
          <div fxFlex>
            <div class="mat-form-field" fxFlex="100" fxLayout="column" fxLayoutAlign="center none">
              <div fxLayout="row"><span>{{'label.common.laboratory' | translate}} *</span></div>
              <div fxLayout="row" fxLayoutAlign="start center">
                <neq-select-autocomplete [dataSource]="searchSupplier"  (change)="onSupplierChange($event)"
                                          formControlName="supplier" [redColor]="isFormInvalidAndTouched('supplier')" fxFlex
                >
                </neq-select-autocomplete>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isFormInvalidAndTouched('supplier')">
          <mat-error *ngIf="mandatoryForm.controls.supplier.errors?.required">
            {{'error.common.field-required'| translate}}
          </mat-error>
        </div>


        <div fxLayout="row">
          <div fxFlex>
            <div class="mat-form-field" fxFlex="100" fxLayout="column" fxLayoutAlign="center none">
              <div fxLayout="row"><span>{{'label.common.requester-email' | translate}} *</span></div>
              <div fxLayout="row" fxLayoutAlign="start center">
                <neq-select-autocomplete [dataSource]="searchRequesters"
                                          formControlName="requester" [redColor]="isFormInvalidAndTouched('requester')" fxFlex
                >
                </neq-select-autocomplete>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isFormInvalidAndTouched('requester')">
          <mat-error *ngIf="mandatoryForm.controls.requester.errors?.required">
            {{'error.common.field-required'| translate}}
          </mat-error>
          <mat-error *ngIf="mandatoryForm.controls.requester.errors?.email">
            {{ 'error.common.email.invalid' | translate }}
          </mat-error>
        </div>

        <div fxLayout="row">
          <div fxFlex>
            <mat-form-field>
              <input select-all [placeholder]="'label.common.farm-name' | translate" formControlName="farmLabel" matInput required>
              <mat-error *ngIf="mandatoryForm.controls.farmLabel.errors?.required">
                {{'error.common.field-required' | translate}}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div fxLayout="row">
          <div fxFlex>
            <div class="mat-form-field" fxFlex="100" fxLayout="column" fxLayoutAlign="center none">
              <div fxLayout="row"><span>{{'label.common.analytic-values-origin' | translate}} *</span></div>
              <div fxLayout="row" fxLayoutAlign="start center">
                <neq-select-autocomplete [dataSource]="searchAnalysis"
                                          formControlName="analysisOrigin" [redColor]="isFormInvalidAndTouched('analysisOrigin')" fxFlex
                >
                </neq-select-autocomplete>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="isFormInvalidAndTouched('analysisOrigin')">
          <mat-error *ngIf="mandatoryForm.controls.analysisOrigin.errors?.required">
            {{'error.common.field-required'| translate}}
          </mat-error>
        </div>

        <div fxLayout="row">
          <div class="mat-form-field">
            <mat-checkbox formControlName="excludeFromTheStats"></mat-checkbox>
            {{'label.common.exclude-from-the-statistics' | translate }}
          </div>
        </div>
      </div>

      <div *ngIf="isFormInvalidAndTouched('excludeFromTheStats')">
        <mat-error *ngIf="mandatoryForm.controls.excludeFromTheStats.errors?.required">
          {{'error.common.field-required'| translate}}
        </mat-error>
      </div>
  </div>

  <aside fxFlex="290px">
    <div class="neq-action-button" fxLayoutAlign="end center">
      <button pButton
        [disabled]="!canSave"
        class="neq-primeng-button primeng-flat"
        [matTooltip]="'msg.common.icon.save' | translate"
        (click)="save()"
      >
        <neq-icon svgIcon="enregistrer"></neq-icon>
      </button>
    </div>
    <neq-event-list [auditableDto]="sample"></neq-event-list>

    <div class="neq-container neq-aside-container">
      <h3>
        <neq-icon svgIcon="notes"></neq-icon>&nbsp;{{ 'label.common.notes' | translate }}
      </h3>
      <textarea select-all matInput [formControl]="notesForm"></textarea>
    </div>
  </aside>
</div>
